class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.productMediaElement = document.querySelector('product-media');
        this.url = this.getAttribute('url') || '';
        this.currentVariant = null;
        this.currentImages = [];
        this.section = this.getAttribute('section') || '';
        this.buttons = Array.from(this.querySelectorAll('button[variant]'));
        this.addEventListener('click', this.onVariantChange.bind(this));
        const selected = this.querySelector('button.-selected');
        selected && selected.click();
    }
    async onVariantChange(e) {
        const target = e.target;
        const button = target.closest('button');
        if (!button?.hasAttribute('variant'))
            return;
        this.currentVariant = JSON.parse(button.getAttribute('variant'));
        this.currentImages = JSON.parse(button.getAttribute('images') || '[]');
        console.log(this.currentVariant);
        console.log(this.productMediaElement);
        if (this.currentImages?.length) {
            // Verifica que productMediaElement esté definido y que pushImages esté disponible
            if (this.productMediaElement && typeof this.productMediaElement.pushImages === 'function') {
                this.productMediaElement.pushImages(this.currentImages);
            }
            else {
                console.error('product-media element or pushImages method not found.');
            }
        }
        this.toggleAddButton(true, 'Cargando', '-disabled');
        this.removeErrorMessage();
        this.updateVariantButtons();
        if (!this.currentVariant.available) {
            await this.renderProductInfo();
            this.setUnavailable();
        }
        else {
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
        }
    }
    /**
     * Change the url of the page to the current variant
     */
    updateURL() {
        if (!this.currentVariant)
            return;
        window.history.replaceState({}, '', `${this.url}?variant=${this.currentVariant.id}`);
    }
    /**
     * Update the variant input with the current variant id
     */
    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.section}, #product-form-installment`);
        productForms.forEach(productForm => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
    removeErrorMessage() {
        const section = this.closest('section');
        if (!section)
            return;
        const productForm = section.querySelector('product-form');
        if (productForm)
            productForm.handleErrorMessage(!this.currentVariant ? 'No disponible' : false);
    }
    /**
     *
     * @param {boolean} disable Disable the add to cart button and checkout button
     * @param {string} text Text to insert into the add to cart button
     * @param {string} modifyClass Class to add or remove
     */
    toggleAddButton(disable = true, text, modifyClass) {
        const productForm = document.getElementById(`product-form-${this.section}`);
        if (!productForm)
            return;
        const addButton = productForm.querySelector('button[name="add"]');
        if (!addButton)
            return;
        disable ? addButton.setAttribute('disabled', 'disabled') : addButton.removeAttribute('disabled');
        if (!modifyClass)
            return;
        disable ? addButton.classList.add(modifyClass) : addButton.classList.remove(modifyClass);
        if (text) {
            const addButtonText = addButton.querySelector('span');
            addButtonText.textContent = text;
        }
    }
    setUnavailable() {
        const form = document.getElementById(`product-form-${this.section}`);
        this.toggleAddButton(true, 'Agotado', '-disabled');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price)
            price.classList.add('u-hide');
        const checkoutLink = document.getElementById(`checkoutLink`);
        if (checkoutLink)
            checkoutLink.classList.add('u-hide');
    }
    updateVariantButtons() {
        this.buttons.forEach((button) => {
            const variant = JSON.parse(button.getAttribute('variant'));
            if (!variant)
                return;
            if (variant.id === this.currentVariant.id) {
                button.classList.add('-selected');
            }
            else {
                button.classList.remove('-selected');
            }
        });
    }
    async renderProductInfo() {
        const response = await fetch(`${this.url}?variant=${this.currentVariant.id}&section_id=${this.section}`);
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const price = document.getElementById(`price-${this.section}`);
        if (price)
            price.classList.remove('u-hide');
        price.innerHTML = html.getElementById(`price-${this.section}`).innerHTML;
        const table = document.getElementById(`table-${this.section}`);
        if (table)
            table.outerHTML = html.getElementById(`table-${this.section}`).outerHTML;
        const checkoutLink = document.getElementById(`checkoutLink`);
        const newCheckoutLink = html.getElementById(`checkoutLink`);
        if (checkoutLink && newCheckoutLink)
            checkoutLink.outerHTML = newCheckoutLink.outerHTML;
        this.toggleAddButton(false, this.currentVariant.available ? 'Agregar al carrito' : 'Agotado', '-disabled');
    }
}
customElements.define('variant-selects', VariantSelects);
